import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { VddOnboardingForm } from '../vdd.interface';

@Injectable()
export class VddOnboardingService {
  private _baseUrl = environment.apiUrl;

  constructor(private _http: HttpClient) {}

  public sendOnboardingEmail(form: VddOnboardingForm) {
    return this._http.post(this._baseUrl + 'v1/vendor/onboarding', form);
  }
}
